import { HTMLProps } from "react";
import { Teacher } from "../../models/teacher/teacher";
import classNames from "classnames";

function TeacherDetails({
  teacher,
  className,
  ...props
}: { teacher: Teacher } & HTMLProps<HTMLDivElement>) {
  return (
    <div className={classNames("grid grid-cols-2 gap-2", className)} {...props}>
      <div className="flex flex-col font-bold">
        <span>Name</span>
        <span>Email</span>
        <span>Telefon</span>
        <span>Extern</span>
      </div>
      <div className="flex flex-col">
        <span>{teacher.fullName}</span>
        <span className="text-th-primary-900 hover:underline">
          <a href={`mailto:${teacher.email}`}>{teacher.email}</a>
        </span>
        <span>{teacher.phone ? teacher.phone : "Keine Angabe"}</span>
        <span>{teacher.internal ? "Nein" : "Ja"}</span>
      </div>
    </div>
  );
}

export default TeacherDetails;
